import Config from "shared/service/config";

export default class EdeoneConfig extends Config {
  constructor(
    apiUrls = { production, preproduction, localdev },
    storeUrls = { production, preproduction, localdev },
    mainUrls = { production, preproduction, localdev }
  ) {
    super(apiUrls, storeUrls, mainUrls);
  }

  get loadItemsOnEveryRouteChange() {
    return false;
  }

  get automodalsConfig() {
    return {
      showModelModerationModals: false,
    };
  }

  get menuConfig() {
    return {
      canSelectProject: true,
      canCreateConsultation: true,
      logoUrl: "https://app.edeone.com/",
      logoTargetBlank: false,
    };
  }

  get accountConfig() {
    return {
      showTarifficationLink: true,
      isUserAuthor: false,
    };
  }

  get courseConfig() {
    return {
      handleCourseItemSellSettingsRouting: (courseEditPageInstance) => {
        courseEditPageInstance.$bvModal.show("sellCourse");
      },
      showGroupManagementTab: true,
      subheaderBackButton: {
        route: {
          path: "/courses",
        },
        caption: "к курсам",
      },
      showKeyAdvantagesInput: false,
      logoCaption: "Логотип",
      showOwnerLink: false,
    };
  }

  get itemConfig() {
    return {
      showModerationStatus: false,
    };
  }

  get shopSettingsConfig() {
    return {
      subheaderTitle: "Настройки",
      shopNameInputCaption: "магазина",
      showDescriptionTextarea: false,
      showEmailSenderInput: true,
      showLinks: false,
      showAccessCard: true,
      showPartnershipSettings: true,
      showKursorTariffcation: false,
      showUserNotifySettings: true,
      showAuthorPageUrl: false,
      showStateSwitcher: false,
      showCatalogCard: true,
    };
  }

  get profileConfig() {
    return {
      showUserNotifySettings: false,
      showDescriptionTextarea: true,
      telegramBot: 'edeone_user_bot'
    };
  }

  get metrikaConfig() {
    return {
      yandex: {
        id: 72324289,
      },
      vk: {
        pixel: {
          id: "VK-RTRG-1025567-adJVW",
        },
      },
      facebook: {
        pixel: {
          id: "513655373242975",
        },
      },
      google: {
        tag: {
          id: "G-QCBZ3FSYTS",
        },
      },
    };
  }

  get footerLinks() {
    return [
      {
        name: "Агентский договор-оферта",
        value: "https://edeone.com/docs/publicoffer.pdf",
      },
      {
        name: "Политика конфиденциальности",
        value: "https://edeone.com/docs/privacypolicy.pdf",
      },
      {
        name: "Пользовательское соглашение",
        value: "https://edeone.com/docs/termsofuse.pdf",
      },
      {
        name: "Публичная оферта Безопасная сделка",
        value: "https://edeone.com/docs/publicoffer_sd.pdf",
      },
    ];
  }

  get supportLink() {
    return 'info@edeone.com';
  }

  get helpLinks() {
    return {
      main: 'https://edeone.com/help',
      item: 'https://edeone.com/help/product',
      promotion: 'https://edeone.com/help/promotion',
      order: 'https://edeone.com/help/orders',
      client: 'https://edeone.com/help/clients',
      statistics: 'https://edeone.com/help/statistic',
      projectSettings: 'https://edeone.com/help/progect-settings',
      integration: 'https://edeone.com/help/integration',
      course: 'https://edeone.com/help/course',
      partnership: 'https://edeone.com/help/partnership',
      coauthorship: 'https://edeone.com/help/for-authors',
      referral: 'https://edeone.com/help/referral-program',
      profile: 'https://edeone.com/help/profile',
      finance: 'https://edeone.com/help/finance',
      tariff: 'https://edeone.com/help/services',
    }
  }

  getEditorStylesUrl = () => this.getMainUrl() + "/css/app-edeone_edeone_editor-styles.css";
  getEditorFonts = () => `
    @font-face {
      font-family: "Roboto-Light";
      font-style: normal;
      font-weight: normal;
      src: url("/fonts/Roboto-Light.woff") format("woff");
      font-display: swap;
    }
    @font-face {
      font-family: "Roboto-Medium";
      font-style: normal;
      font-weight: normal;
      src: url("/fonts/Roboto-Medium.woff") format("woff");
      font-display: swap;
    }
    @font-face {
      font-family: "Roboto-Italic";
      font-style: normal;
      font-weight: normal;
      src: url("/fonts/Roboto-Italic.woff") format("woff");
      font-display: swap;
    }
  `;
}
